import { Injectable } from '@angular/core';
import { Logger } from '@ngrx/data';
import * as Sentry from '@sentry/angular-ivy';

@Injectable()
export class CcoLogger implements Logger {
  error(message?: any, extra?: any) {
    if (message) {
      if (this.notError(message))
        return;
      extra ? Sentry.captureException(message, {
          extra,
        }) : Sentry.captureException(message);
      extra ? console.error(message, extra) : console.error(message);
    }
  }

  log(message?: any, extra?: any) {
    if (message) {
      // eslint-disable-next-line no-console
      extra ? console.log(message, extra) : console.log(message);
    }
  }

  warn(message?: any, extra?: any) {
    if (message) {
      extra ? console.warn(message, extra) : console.warn(message);
    }
  }

  notError(message: any) {
    return message.error?.error?.status === 404
      || (message.error?.error?.status === 400 && message.error?.error?.message === 'Data Validation Failure'); // jakarta.validation
  }
}
